import React from 'react'
import RosterForm from 'src/supportPortal/views/roster/component/RosterForm'

export default function TherapistRosterForm({ ...rest }) {
  return (
    <RosterForm
      {...rest}
      dropDownKey="chamberRoomId"
      dropDownLabel="Chamber"
      slotSaveApiSignature="/api/secure/cc/support/roster/assign-therapist-to-chamber"
      transformToSaveItem={({ rosterSaveItem, allSidebarItems }) => {
        const foundRoom = allSidebarItems.find((room) => room.id === rosterSaveItem.chamberRoomId)

        return {
          ...rosterSaveItem,
          chamberRoomId: foundRoom?.id,
          clinicBrandId: foundRoom?.clinicBrandId,
          clinicLocationId: foundRoom?.clinicLocationId,
          mentorId: rosterSaveItem.mentorId,
        }
      }}
    />
  )
}
